import io from 'socket.io-client'
import {Events} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import * as Sentry from '@sentry/vue'
let _socket
let _userId
let _landscapeId
let _store
let ONLINE = true

// Check connection status
window.addEventListener('online', () => {
  ONLINE = true
  create()
})
window.addEventListener('offline', () => {
  ONLINE = false
})

const onMessage = data => {
  _store.dispatch('updateMentions', data.mentions)
  _store.dispatch('updateLandscapeListMentions', data.landscapes)
  if (data.updates) {
    _store.dispatch('updateNewTopics', data.updates)
    _store.dispatch('updateNewSources', data.updates)
  }
  if (data.refresh && new Date(data.refresh) > _store.getters.accessDate) {
    EventHub.emit(Events.SHOW_RELOAD_WARNING)
  }
}

const onOpen = () => {
  console.log('socket open')
}

const onError = e => {
  // TODO: reconnect?
  console.log('socket error', e)
}

const onClose = e => {
  console.log('socket closed', e)
  if (e === 'io server disconnect') {
    setTimeout(create, 500)
  } else if (_socket) {
    _socket.removeAllListeners()
    if (_socket.connected) _socket.close()
  }
  _socket = null
}

const create = (userId, landscapeId, store) => {
  onClose()
  _store = store || _store
  _userId = userId || _userId
  _landscapeId = landscapeId || _landscapeId
  if (ONLINE && _userId) {
    try {
      _socket = io(process.env.VUE_APP_WSS_URL, {
        query: {
          landscape: _landscapeId,
          user: _userId
        }
      })
      _socket.on('error', onError)
      _socket.on('connect', onOpen)
      _socket.on('disconnect', onClose)
      _socket.on('data', onMessage)
    } catch (e) {
      console.log('fatal error creating socket', e)
      Sentry.captureException(e)
    }
  }
}

export default {create}
